'use client'
import { useState } from 'react'
import { useCartStore } from '@/stores/cartStore'
import dynamic from 'next/dynamic'

const FiCheck = dynamic(() => import('react-icons/fi').then(mod => mod.FiCheck), { ssr: false })

interface QuickAddVariantButtonProps {
  productId: string
  quantity: number
  label: string
}

export default function QuickAddVariantButton({ productId, quantity, label }: QuickAddVariantButtonProps) {
  const [isAdding, setIsAdding] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const addItem = useCartStore((state) => state.addItem)
  
  const handleClick = async () => {
    setIsAdding(true)
    try {
      // Add the product to the cart using the Zustand store with the specified quantity
      addItem(productId, quantity, undefined)
      
      // Show success animation
      setSuccess(true)
      setTimeout(() => {
        setSuccess(false)
        setIsAdding(false)
      }, 1000)
    } catch (err) {
      console.error('Error adding product to cart:', err)
      setIsAdding(false)
    }
  }
  
  return (
    <button
      onClick={handleClick}
      disabled={isAdding}
      aria-label={label}
      className={`
        flex-1 py-2 px-3 rounded-full text-sm font-semibold transition-all duration-300
        ${success 
          ? 'bg-status-success/20 border border-status-success text-status-success'
          : 'bg-text-main text-bg-main hover:bg-secondary hover:text-static-white'
        }
      `}
    >
      <span className="flex items-center justify-center gap-1">
        {success ? <FiCheck className="inline-block" /> : null}
        <span>{label}</span>
      </span>
    </button>
  )
} 